
import React, {useContext, useEffect, useState} from "react";
import Main from "../Layout/Main";
import AuthContext from "../Services/AuthContext";
import {Link, useNavigate} from "react-router-dom";
import {Alert, Button, CircularProgress, Paper, Stack, TextField, Typography} from "@mui/material";
import {Save} from "@mui/icons-material";
import dbDate from "../Utilities/dbDate";
import dbTime from "../Utilities/dbTime";


function Profile() {
    const [user] = useContext(AuthContext);
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [sending, setSending] = useState(false);
    const [alert, setAlert] = useState('');

    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/user`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setName(data.name);
                    setSurname(data.surname);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [user.token])

    function send() {
        setAlert('');
        const formData = {
            name: name,
            surname: surname
        };
        fetch(`/api/user`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                setSending(false);
                setAlert(<Alert severity="success">Zaktualizowano dane profilowe</Alert>);
            })
            .catch(err => {
                console.log(err);
                setSending(false);
                setAlert(<Alert severity="error">Wystąpił błąd aktualizacji danych</Alert>);
            })
    }

    return (<Main title='Mój Profil' >
        <Paper elevation={24} sx={{maxWidth: '95vw', width: '1200px', padding: '10px 30px', textAlign: 'left', marginBottom: 2}}>
            <Stack direction={'column'} spacing={2}>
                <Typography variant={'h2'} fontSize={'xx-large'} >{user.username}</Typography>
                {alert}
                <TextField type={'text'} value={name} onChange={(e) => setName(e.target.value)} label={'Imię'}/>
                <TextField type={'text'} value={surname} onChange={(e) => setSurname(e.target.value)} label={'Nazwisko'}/>
                <Button startIcon={sending === true ? <CircularProgress color="light" size={'1rem'}/> : <Save color="light" size={'1rem'}/>} onClick={() => {setSending(true); send();}} color={'primary'} disabled={sending} variant={'contained'}>Aktualizuj</Button>
                <Typography variant={'p'} fontSize={'medium'} >Chcesz zmienić hasło ? Przejdź do formularza <Typography
                    component={Link}
                    to="/reset"
                    color="info"
                >
                    resetu hasła
                </Typography></Typography>
            </Stack>
            </Paper>
    </Main>);
}

export default Profile;